module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Half-star-eb4ac5b74f3634e9d0594a880a44e436.svg";